import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// import NotFound from "@/components/NotFound";
import ForgotPass from "@/components/ForgotPass";
import Register from "@/components/Register";
import KasProAgen from "@/components/admin/KasProAgen";
import MitraServer from "@/components/admin/MitraServer";
import ChangePassword from "@/components/ChangePassword";
import Home from "@/components/Home";
import AppList from "@/components/AppList";
import Appmenu from "@/components/Appmenu";
import Kategori from "@/components/Kategori";
import News from "@/components/News";
import Popup from "@/components/Popup";
import Reseller from "@/components/Reseller";
import Slider from "@/components/Slider";
import Product from "@/components/Product";
import Login from "@/components/Login";
import RunningTextPage from "@/components/RunningTextPage";
import SMSTokenPage from "@/pages/SMSTokenPage";
import SMSOrderOrderCreate from "@/pages/SMSOrderOrderCreate";
import SMSTokenOrderSUkses from "@/pages/SMSTokenOrderSUkses";
import TopupChannelPage from "@/pages/TopupChannelPage";
import Landing from "@/pages/Landing";
import ResetPassToken from "@/pages/ResetPassToken";
import ActivateUser from "@/pages/ActivateUser";
import PageWallet from "@/pages/PageWallet";
import IRMACapital from "@/pages/IRMACapital";
import ModalKerja from "@/pages/ModalKerja";
import DeleteAkun from "@/components/DeleteAkun";
import DigiPost from "@/components/aktivasimodule/Digipost";
import Isimple from "@/components/aktivasimodule/Isimple"
import Sidompul from "@/components/aktivasimodule/Sidompul"


Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'landing',
      meta: {
        public: true
      },
      component: Landing
    },
    {
      path: '*',
      name: 'notfound',
      meta: {
        public: true
      },
      component: Login
    },
    {
      path: '/forgot',
      name: 'forgotpassword',
      meta: {
        public: true
      },
      component: ForgotPass
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        public: true
      },
      component: Register
    },
    {
      path: '/admin/agenkaspro',
      name: 'kasproagen',
      meta: {
        adminAuth: true, breadcrumb: true
      },
      component: KasProAgen
    },
    {
      path: '/admin/mitraserver',
      name: 'mitraserver',
      meta: {
        adminAuth: true, breadcrumb: true
      },
      component: MitraServer
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      meta: { breadcrumb: true },
      component: ChangePassword
    },
    {
      path: '/dashboard',
      name: 'home',
      meta: { breadcrumb: true },
      component: Home
    },
    {
      path: '/applist',
      name: 'applist',
      meta: { breadcrumb: true },
      component: AppList
    },
    {
      path: '/appmenu',
      name: 'appmenu',
      meta: { breadcrumb: true },
      component: Appmenu
    },
    {
      path: '/kategori',
      name: 'kategori',
      meta: { breadcrumb: true },
      component: Kategori
    },
    {
      path: '/news',
      name: 'news',
      meta: { breadcrumb: true },
      component: News
    },
    {
      path: '/deleteakun',
      name: 'deleteakun',
      meta: { breadcrumb: true },
      component: DeleteAkun
    },
    {
      path: '/digipos',
      name: 'digipos',
      meta: { breadcrumb: true },
      component: DigiPost
    },
    {
      path: '/isimple',
      name: 'isimple',
      meta: { breadcrumb: true },
      component: Isimple
    },
    {
      path: '/sidompul',
      name: 'sidompul',
      meta: { breadcrumb: true },
      component: Sidompul
    },
    {
      path: '/popup',
      name: 'popup',
      meta: { breadcrumb: true },
      component: Popup
    },
    {
      path: '/runningtext',
      name: 'runningtext',
      meta: { breadcrumb: true },
      component: RunningTextPage
    },
    {
      path: '/tokensms',
      name: 'tokensms',
      meta: { breadcrumb: true },
      component: SMSTokenPage
    },
    {
      path: '/tokensms/order/create',
      name: 'tokensmsordercreate',
      meta: { breadcrumb: true },
      component: SMSOrderOrderCreate
    },
    {
      path: '/tokensms/order/success/:orderid',
      name: 'smstokenordersukses',
      meta: { breadcrumb: true },
      component: SMSTokenOrderSUkses
    },
    {
      path: '/topupchannel',
      name: 'topupchannel',
      meta: { breadcrumb: true },
      component: TopupChannelPage
    },
    {
      path: '/wallet',
      name: 'wallet',
      meta: { breadcrumb: true },
      component: PageWallet
    },
    {
      path: '/modalkerja',
      name: 'modalkerja',
      meta: { breadcrumb: true },
      component: IRMACapital
    },
    {
      path: '/modalkerjav2',
      name: 'modalkerjav2',
      meta: { breadcrumb: true },
      component: ModalKerja
    },
    {
      path: '/mitraagen',
      name: 'mitraagen',
      meta: { breadcrumb: true },
      component: Reseller
    },
    {
      path: '/slider',
      name: 'slider',
      meta: { breadcrumb: true },
      component: Slider
    },
    { path: '/product', name: 'product', meta: { breadcrumb: true }, component: Product },
    {
      path: '/login',
      name: 'LoginPage',
      meta: {
        public: true
      },
      component: Login
    },
    {
      path: '/resetpass/:token',
      meta: {
        public: true,
      },
      component: ResetPassToken,
    },
    {
      path: '/activate/:token',
      meta: {
        public: true,
      },
      component: ActivateUser,
    }
  ]
})

// router gards
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  NProgress.done()
})

export default router
